'use server'

import { setA11yCookie } from '@/lib/a11y/cookie'
import { AccessibilitySettingsSchema, type AccessibilitySettings } from '@/lib/a11y/types'
import { getUserSession } from '@/lib/auth/session'
import { strapiSavePreferences } from '@/lib/auth/strapi-auth'

/**
 * Čuva a11y postavke: uvek u cookie (za SSR), a kada je korisnik prijavljen i
 * trajno na njegov nalog u Strapi-ju (system preferences koje ga prate).
 */
export async function saveA11yCookie(settings: AccessibilitySettings): Promise<void> {
  const parsed = AccessibilitySettingsSchema.safeParse(settings)
  if (!parsed.success) {
    throw new Error('Nevažeće accessibility postavke')
  }

  await setA11yCookie(parsed.data)

  const session = await getUserSession()
  if (session) {
    try {
      await strapiSavePreferences(session.jwt, { a11ySettings: parsed.data })
    } catch {
      // Strapi nedostupan — cookie/localStorage i dalje čuvaju na uređaju.
    }
  }
}
